import { useArtifactPanelStore } from '@/stores/artifactPanelStore.js';
import { ExplorerSidebar } from './Explorer/ExplorerSidebar.js';
import { TabBar } from './Tabs/TabBar.js';
import { ContentArea } from './Content/ContentArea.js';
import { Button } from '@/components/ui/button.js';
import { PanelLeftOpen } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip.js';

export function ArtifactPanel() {
  const sidebarCollapsed = useArtifactPanelStore((state) => state.sidebarCollapsed);
  const sidebarWidth = useArtifactPanelStore((state) => state.sidebarWidth);
  const toggleSidebar = useArtifactPanelStore((state) => state.toggleSidebar);
  const layoutOrientation = useArtifactPanelStore((state) => state.layoutOrientation);

  return (
    <div className={`flex h-full bg-muted/30 ${layoutOrientation === 'left' ? 'border-r' : 'border-l'} border-primary/20 animate-artifact-panel`}>
      {/* Explorer Sidebar */}
      {!sidebarCollapsed && (
        <div
          className="flex-shrink-0 h-full bg-muted/50"
          style={{ width: `${sidebarWidth}px` }}
        >
          <ExplorerSidebar />
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-full bg-background">
        {/* Tab Bar with inline expand button when sidebar is collapsed */}
        <div className="flex items-center gap-2 px-4 py-2 border-b border-border bg-muted/20">
          {/* Expand button when collapsed - inline with tabs */}
          {sidebarCollapsed && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7 flex-shrink-0"
                  onClick={toggleSidebar}
                >
                  <PanelLeftOpen className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Expand sidebar</p>
              </TooltipContent>
            </Tooltip>
          )}

          {/* Tab bar content without its own border/padding wrapper */}
          <TabBar />
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden">
          <ContentArea />
        </div>
      </div>
    </div>
  );
}
